module.exports = __webpack_public_path__ + "img/map_lock.6a3e83c9.svg";